const OrderListHeader = () => (
  <div className="order-list-header hidden md:block" aria-hidden="true">
    <div className="order-smart-grid order-smart-grid--no-customer order-list-header-grid">
      <span className="order-list-header-cell">Order</span>
      <span className="order-list-header-cell order-list-header-cell--type">Type</span>
      <span className="order-list-header-cell">Status</span>
      <span className="order-list-header-cell order-list-header-cell--amount">Amount</span>
      <span className="order-list-header-cell order-list-header-cell--actions">Actions</span>
    </div>
  </div>
);

export default OrderListHeader;
